<template>
	<el-row id="industry-intro">
		<el-col :lg="4" :xl="4">
			<div class="hidden-md-and-down">&nbsp;</div>
		</el-col>
		<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
			<div class="ind-container">
				<h2>{{data.title}}</h2>
				<p style="margin-bottom: 20px;">{{data.content}}</p>
				<div class="box">
					<div class="item" v-for="item in data.items" :key="item.id">
						<img :src="item.src" />
						<p>{{item.content}}</p>
					</div>
				</div>
			</div>
		</el-col>
		<el-col :lg="4" :xl="4">
			<div class="hidden-md-and-down">&nbsp;</div>
		</el-col>
	</el-row>
</template>

<script>
	export default {
		name: 'IndustryPainSpot',
		props: ['data']
	}
</script>

<style>
	@media (min-width:992px) {
		.ind-container {
			widows: 100%;
			height: 287px;
			display: flex;
			flex-flow: column nowrap;
			justify-content: space-between;
			align-items: center;
		}

		.ind-container h2 {
			font-weight: 500;
			font-size: 20px;
			font-family: "microsoft yahei";
			color: #333333;
		}

		.ind-container p {
			font-size: 14px;
			font-family: "microsoft yahei";
			color: #848484;
		}

		.ind-container .box {
			width: 100%;
			height: 150px;
			display: flex;
			flex-flow: row wrap;
			justify-content: space-around;
		}

		.ind-container .box .item {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
		}
	}

	@media (max-width:992px) {
		.ind-container {
			widows: 100%;
			display: flex;
			flex-flow: column nowrap;
			justify-content: space-around;
			align-items: center;
		}

		.ind-container h2 {
			font-weight: 500;
			font-size: 18px;
			font-family: "microsoft yahei";
			color: #333333;
			line-height: 60px;
		}

		.ind-container p {
			font-size: 12px;
			font-family: "microsoft yahei";
			color: #848484;
			line-height: 1.5;
		}

		.ind-container .box {
			width: 100%;
			display: flex;
			flex-flow: column nowrap;
			justify-content: space-around;
		}

		.ind-container .box .item:not(:last-child) {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/IndustryPainSpot.vue